import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { NotificationType } from '../Enums/NotificationType.enum';

export class InputNotificationKey<T extends EMode = EMode.entity> {
  /** Alias: notificationType */
  notificationType?: NotificationType;
  /** Alias: entityId */
  entityId?: string;

  __typename?: string;
}

const fields: FieldDefinitions<InputNotificationKey> = {
  notificationType: {
    alias: 'notificationType',
  },
  entityId: {
    alias: 'entityId',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputNotificationKeyEntityDefinition: EntitiyDefinition<InputNotificationKey> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputNotificationKey',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
